import { useRef } from 'react';
import { AccordionTabsCategory } from '../GeneralItemsCategoryPage/styled';
import { InputFieldCategory, TabsItemCategory } from './styled';

export default function FaqsComponent(props) {
  const { question, handleStateChangeCollapsable, index, resultPage } = props;
  const id = `tabIndexes${index}`;
  const sectionHeightRef = useRef();
  return (
    <>
      <AccordionTabsCategory key={`faq${index}`}>
        <InputFieldCategory
          type="checkbox"
          id={id}
          name="check"
          defaultChecked={false}
        />
        <TabsItemCategory resultPage={resultPage} className="tabsItem">
          <label
            className="tab-label"
            htmlFor={id}
            onClick={() => {
              handleStateChangeCollapsable(
                sectionHeightRef.current.offsetHeight,
                question?.questionName,
                index,
              );
            }}
          >
            <p className="question_name"> {question?.questionName} </p>
          </label>
          <div className="tab-content" ref={sectionHeightRef}>
            <div
              dangerouslySetInnerHTML={{
                __html: question?.acceptedAnswerText,
              }}
            ></div>

            {question?.answerFeatures?.map((feature, idx) => {
              return (
                <div key={'subFeature' + idx} className="flex">
                  <span></span>
                  <p className="featureText">{feature?.text}</p>
                  <img className="featureImg" src={feature?.icon} alt="" />
                </div>
              );
            })}
          </div>
        </TabsItemCategory>
      </AccordionTabsCategory>
    </>
  );
}
